import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { Table } from 'ui/table';

export const TableWithBottomBorder = styled(Table)`
  border-bottom: ${spacing.single} solid ${colors.borderPrimary};
`;

export const EmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  justify-content: center;
  padding: ${spacing.x4};
  position: relative;
  width: 100vw;
`;
